import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicies() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mx: "auto",
        width: "80vw",
        gap: 2,
      }}
    >
      <Typography variant="h4">{t("Πολιτική Απορρήτου")}</Typography>
      <Typography variant="subtitle2">
        {t("Πολιτική Προστασίας Προσωπικών Δεδομένων")}
      </Typography>
      <Typography variant="body1">
        {t(
          "Η Κεντρική Ένωση Επιμελητηρίων Ελλάδος (εφεξής: ΚΕΕΕ), νομικό πρόσωπο δημοσίου δικαίου, το οποίο συστάθηκε με το άρθρο 5 του ν. 2081/1992 (Α΄ 154), με έδρα την Αθήνα (Ακαδημίας, αρ. 6) και έχει ως μέλη της όλα τα Επιμελητήρια της χώρας, ενημερώνει με την παρούσα σύμφωνα με τις διατάξεις του Κανονισμού (ΕΕ) 2016/679 (Γενικός Κανονισμός για την Προστασία των Δεδομένων, εφεξής ΓΚΠΔ) και τις διατάξεις της εθνικής νομοθεσίας περί προστασίας δεδομένων προσωπικού χαρακτήρα (ν. 4624/2019), υπό την ιδιότητα της Υπεύθυνης Επεξεργασίας (σύμφωνα με το άρθ. 87, παρ. 1 ιδ του ν. 4919/2022), ότι επεξεργάζεται δεδομένα προσωπικού χαρακτήρα στο πλαίσιο των αρμοδιοτήτων της με σκοπό την εκπλήρωση της αποστολής της. Η παρούσα πολιτική προστασίας δεδομένων αφορά την επεξεργασία προσωπικών δεδομένων στο πλαίσιο της υπηρεσίας «Ηλεκτρονικής Υποβολής» (services.businessportal.gr), όπως αυτή έχει υλοποιηθεί δυνάμει των διατάξεων του ν. 4919/2022 και της ΚΥΑ Κ2-4946/2014.",
        )}
      </Typography>
      <List sx={{ listStyle: "decimal", pl: 4 }}>
        <ListItem>
          <ListItemText sx={{ display: "list-item" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6">
                {t(
                  "Ποια δεδομένα προσωπικού χαρακτήρα συλλέγει και επεξεργάζεται η ΚΕΕΕ;",
                )}
              </Typography>
              <Typography>
                {t(
                  "Στο πλαίσιο της λειτουργίας της υπηρεσίας «Ηλεκτρονικής Υποβολής» (services.businessportal.gr εφεξής: Υπηρεσία) η ΚΕΕΕ επεξεργάζεται προσωπικά δεδομένα είτε για την είσοδό σας στην Υπηρεσία, είτε προσωπικά δεδομένα που υπόκεινται σε επεξεργασία και δημοσιότητα, βάσει της κείμενης νομοθεσίας, ιδίως βάσει των διατάξεων του ν. 4919/2022 και των άρθρων 85 έως 116 του ν. 4919/2022 περί ΓΕΜΗ, του Γενικού Κανονισμού για την Προστασία Δεδομένων (Κανονισμός [ΕΕ] 2016/679), του ν. ν. 4624/2019, του ν. 4548/2018 περί αναμόρφωσης του δικαίου των ανωνύμων εταιρειών, ν. 3190/1955 περί ΕΠΕ, των άρθρων 43-120 & 130 του ν. 4072/2012 περί ΙΚΕ και των άρθρων 249-294 του ν. 4072/2012 περί προσωπικών εταιρειών, όπως τα ως άνω νομοθετήματα έχουν τροποποιηθεί και ισχύουν.",
                )}
              </Typography>
              <Typography>
                {t("Συγκεκριμένα, τα προσωπικά αυτά δεδομένα είναι τα κάτωθι:")}
              </Typography>
              <List
                sx={{
                  listStyle: "decimal",
                  pl: 4,
                  lineHeight: 2,
                }}
              >
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "Βασικά δεδομένα: όνομα, επώνυμο, πατρώνυμο, e-mail, τηλέφωνο, χώρα, πόλη, οδός, αριθμός, διεύθυνση",
                  )}
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  {t(
                    "Μοναδικά αναγνωριστικά: ΑΦΜ, αριθμός ταυτότητας, επιθυμητό username, password, αριθμός πληρωμής, αριθμός διαβατηρίου, αριθμός ΟΕΕΕ, αριθμός ΣΟΕΛ, αριθμός ΕΛΤΕ",
                  )}
                </ListItemText>
                <ListItemText sx={{ display: "list-item" }}>
                  {t("Οικονομικά δεδομένα: τρόπος πληρωμής, ποσό πληρωμής")}
                </ListItemText>
              </List>
            </Box>
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">
              {t(
                "Σκοποί επεξεργασίας και νομιμοποιητική βάση επεξεργασίας προσωπικών δεδομένων",
              )}
            </Typography>
            <Typography>
              {t(
                "Οι σκοποί επεξεργασίας προσωπικών δεδομένων μέσω της Υπηρεσίας είναι οι κάτωθι:",
              )}
            </Typography>
            <List
              sx={{
                listStyle: "circle",
                pl: 4,
                lineHeight: 2,
              }}
            >
              <ListItemText sx={{ display: "list-item" }}>
                {t("Εγγραφή μη υπόχρεου χρήστη,")}
              </ListItemText>
              <ListItemText sx={{ display: "list-item" }}>
                {t("Διαχείριση αιτημάτων για πιστοποιητικά / αντίγραφα.")}
              </ListItemText>
            </List>
            <Typography>
              {t(
                "Το σύνολο των ως άνω σκοπών επεξεργασίας βασίζεται στη νομιμοποιητική βάση του δημοσίου συμφέροντος ή στην άσκηση δημόσιας εξουσίας (άρθρο 6.1 ε ΓΚΠΔ) που έχει ανατεθεί στην ΚΕΕΕ ως Επιμελητηριακή Αρχή.",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">
              {t("Τρόπος και πηγές άντλησης δεδομένων προσωπικού χαρακτήρα")}
            </Typography>
            <Typography>
              {t(
                "Η ΚΕΕΕ συλλέγει δεδομένα από εσάς απευθείας και από τα αρμόδια Επιμελητήρια μέσω ηλεκτρονικής εισαγωγής δεδομένων στην πλατφόρμα services.businessportal.gr.",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">
              {t("Διαβίβαση προσωπικών δεδομένων")}
            </Typography>
            <Typography>
              {t(
                "Η ΚΕΕΕ διαβιβάζει τα ανωτέρω δεδομένα σε τρίτους μόνον όταν αυτό προβλέπεται από την υφιστάμενη νομοθεσία ως υποχρέωση της, ήτοι στη ΜΟΔ Α.Ε. για την τήρηση αντιγράφου ασφαλείας και σύμφωνα με τις εγγυήσεις που προβλέπονται στην υφιστάμενη νομοθεσία και το υψηλότερο δυνατό επίπεδο ασφάλειας, ήτοι στην εταιρεία Knowledge Α.Ε., η οποία είναι υπεύθυνη για την τεχνική υλοποίηση της Υπηρεσίας.",
              )}
            </Typography>
            <Typography>
              {t(
                "Αποδέκτες των προσωπικών σας δεδομένων μπορεί να είναι χρήστες της Υπηρεσίας με έννομο συμφέρον προς λήψη των εγγράφων (αρ. 111 Ν.4919/2022). Επιπλέον, τονίζεται ότι τα προσωπικά σας δεδομένα σας δεν διαβιβάζονται σε φορείς που βρίσκονται εντός του Ευρωπαϊκού Οικονομικού Χώρου.",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">{t("Ασφάλεια δεδομένων")}</Typography>
            <Typography>
              {t(
                "Η ασφάλεια των προσωπικών σας δεδομένων είναι μια υψηλή προτεραιότητα για την ΚΕΕΕ. Ως εκ τούτου, η ΚΕΕΕ προστατεύει τα δεδομένα σας μέσω τεχνικών και οργανωτικών μέτρων για την ασφάλεια και την προστασία των αυτών από κάθε μορφής τυχαία ή αθέμιτη επεξεργασία. Τονίζεται δε ότι οι υπάλληλοι της ΚΕΕΕ, οι οποίοι επεξεργάζονται τα προσωπικά δεδομένα δεσμεύονται για την τήρηση του απορρήτου. Τα μέτρα που λαμβάνονται, επανεξετάζονται και τροποποιούνται όταν κρίνεται απαραίτητο.",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">
              {t("Διάρκεια αποθήκευσης δεδομένων")}
            </Typography>
            <Typography>
              {t(
                "Τα προσωπικά σας δεδομένα διατηρούνται μόνον για το διάστημα που απαιτείται προκειμένου να επιτελεστεί ο σκοπός για τον οποίο έχει γίνει η επεξεργασία τους, εκτός εάν προβλέπεται ή επιτρέπεται από την ισχύουσα νομοθεσία διαφορετική περίοδος διατήρησης. Ειδικά ηλεκτρονικό αρχείο των αιτήσεων για χορήγηση πιστοποιητικών και αντιγράφων, των εκδοθέντων πιστοποιητικών και αντιγράφων και των σχετικών πληρωμών ισχύει η περίοδος διατήρησής του για πέντε (5) έτη (άρθ. 9 Κ.Υ.Α. αριθμ. Κ2-4946/15.10.2014).",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">{t("Τα δικαιώματά σας")}</Typography>
            <Typography>
              {t(
                "Η ΚΕΕΕ προστατεύει και διασφαλίζει τα δικαιώματά σας ως προς τη χρήση των προσωπικών δεδομένων σας και συγκεκριμένα έχετε τα κάτωθι δικαιώματα:",
              )}
            </Typography>
            <List
              sx={{
                listStyle: "decimal",
                pl: 4,
                lineHeight: 2,
              }}
            >
              <ListItemText sx={{ display: "list-item" }}>
                {t("δικαίωμα πρόσβασης στα προσωπικά σας δεδομένα,")}
              </ListItemText>
              <ListItemText sx={{ display: "list-item" }}>
                {t("δικαίωμα διόρθωσης των προσωπικών σας δεδομένων,")}
              </ListItemText>
              <ListItemText sx={{ display: "list-item" }}>
                {t(
                  "δικαίωμα περιορισμού της επεξεργασίας των προσωπικών σας δεδομένων (α) όταν αμφισβητείτε την ακρίβεια των προσωπικών δεδομένων και μέχρι την επαλήθευσή τους (β) όταν αντιτίθεστε στη διαγραφή προσωπικών δεδομένων αλλά δεν επιθυμείτε τη διαγραφή τους, (γ) όταν τα προσωπικά δεδομένα δεν είναι απαραίτητα για τους σκοπούς επεξεργασίας, είναι ωστόσο απαραίτητα για τη θεμελίωση, άσκηση, υποστήριξη νομικών αξιώσεων, και (δ) όταν εναντιώνεστε στην επεξεργασία και μέχρι να γίνει επαλήθευση ότι υπάρχουν νόμιμοι λόγοι που μας αφορούν και υπερισχύουν των λόγων για τους οποίους εναντιώνεστε στην επεξεργασία.",
                )}
              </ListItemText>
              <ListItemText sx={{ display: "list-item" }}>
                {t(
                  "δικαίωμα φορητότητας των προσωπικών σας δεδομένων σε άλλον Υπεύθυνο Επεξεργασίας,",
                )}
              </ListItemText>
              <ListItemText sx={{ display: "list-item" }}>
                {t(
                  "δικαίωμα εναντίωσης στην επεξεργασία των προσωπικών σας δεδομένων,",
                )}
              </ListItemText>
              <ListItemText sx={{ display: "list-item" }}>
                {t(
                  "δικαίωμα διαγραφής των προσωπικών σας δεδομένων (να σημειωθεί όταν εάν η διαγραφή τους είναι αδύνατη για την εκπλήρωση κανονιστικών υποχρεώσεων, η ΚΕΕΕ σας ενημερώνει αντιστοίχως)",
                )}
              </ListItemText>
            </List>
            <Typography>
              {t(
                "Μπορείτε να ασκήσετε τα δικαιώματά σας με αίτημα στην κάτωθι διεύθυνση: dpo@uhc.gr",
              )}
            </Typography>
            <Typography>
              {t(
                "Η απάντηση της ΚΕΕΕ στο αίτημά σας θα λάβει χώρα εντός της εκ του νόμου προβλεπόμενης προθεσμίας ενός (1) μηνός από τη λήψη του. Αν χρειαστεί παράταση δύο (2) μηνών για την απάντηση στο αίτημά σας, λόγω της πολυπλοκότητας αυτού ή λόγου του μεγάλου αριθμού των αιτημάτων η ΚΕΕΕ θα σας ενημερώσει αιτιολογημένα το συντομότερο δυνατό.",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Typography variant="h6">
            {t(
              "Εάν δεν έχετε απάντηση στο αίτημά σας έχετε δικαίωμα να υποβάλλετε καταγγελία στην Αρχή Προστασίας Προσωπικών Δεδομένων (ταχυδρομική δ/νση Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, τηλ. 210. 6475600, δ/νση ηλεκτρονικού ταχυδρομείου (e-mail: contact@dpa.gr).",
            )}
          </Typography>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">
              {t("Αυτοματοποιημένη λήψη αποφάσεων και κατάρτιση προφίλ")}
            </Typography>
            <Typography>
              {t(
                "Η ΚΕΕΕ δεν προβαίνει σε λήψη αποφάσεων αποκλειστικά βάσει αυτοματοποιημένης επεξεργασίας δεδομένων προσωπικού χαρακτήρα, ούτε στην κατάρτιση προφίλ, κατά τα οριζόμενα στο άρθρο 22 ΓΚΠΔ.",
              )}
            </Typography>
          </Box>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography variant="h6">
              {t(
                "Τροποποιήσεις στις παρούσες πληροφορίες περί Προστασίας Προσωπικών Δεδομένων",
              )}
            </Typography>
            <Typography>
              {t(
                "Η ΚΕΕΕ δύναται να τροποποιεί την παρούσα Πολιτική Προστασίας Προσωπικών Δεδομένων, όταν κρίνεται απαραίτητο για λόγους συμμόρφωσης με νομοθετικές/κανονιστικές μεταβολές, για επιμελητηριακούς σκοπούς ή προκειμένου να ανταποκριθεί στις ανάγκες των μελών του.",
              )}
            </Typography>
          </Box>
        </ListItem>
      </List>
      <Typography>{t("Ημερομηνία Δημοσίευσης: 11/07/2022")}</Typography>
    </Box>
  );
}
